import { defineMessages } from 'react-intl';

type MessageKeys = 'backLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		backLabel: {
			id: 'fabric.editor.ai.components.backIconButton.backLabel',
			defaultMessage: 'Back',
			description:
				'Label and tooltip for a back navigation icon button in the AI modal. Shown on a small chevron-left button that navigates the user to the previous view. The text "Back" appears as the button\'s accessible label and as a tooltip on hover.',
		},
	});

export default message;
